import React from 'react';
import MessageCell from '@/components/table/MessageCell';

const AttachmentMessageCells = ({ attachment, hasView, hasTransfer }) => {
  const { viewing, transferable } = attachment.metadata;
  return (
    <>
      {hasView && (<MessageCell messageId={`dataset.attachments.viewing.${viewing}`} />)}
      {hasTransfer && (<MessageCell messageId={`dataset.attachments.transferable.${transferable}`} />)}
    </>
  );
};

export default AttachmentMessageCells;
